
import React from "react";
import { Route, Routes } from "react-router-dom";
import BannerList from "../../component/Setting/Banner/BannerList";
import BannerForm from "../../component/Setting/Banner/BannerForm";

function BannerPage() {
  return (
    <Routes>
      <Route path="/*" element={<BannerList />} />
      <Route path="/:id" element={<BannerForm />} />
      <Route path="/edit/:id" element={<BannerForm isEdit={true} />} />
      <Route path="/new" element={<BannerForm isEdit={false} />} />
    </Routes>
  );
}

export default BannerPage;
